import { Link } from 'react-router-dom'
import styles from './NotFoundPage.module.css'

export function NotFoundPage() {
  return (
    <div className={styles.page}>
      <h1>404</h1>
      <p>Página não encontrada.</p>
      <Link to="/" className={styles.link}>
        Voltar ao início
      </Link>
    </div>
  )
}
